// P3-9a (remate) — la celda de FOTO de una fila de variación con estado visual
// mientras la foto se procesa/asocia: «Cargando…» (miniatura gris + spinner),
// «listo» (miniatura nueva) o «error» (motivo + Reintentar). No bloquea el resto
// del formulario: es solo esta celda. Componente puro de presentación.
import React from 'react';
import { Camera, ImagePlus, Loader2, AlertCircle, RotateCw } from 'lucide-react';

export default function CeldaFotoVariacion({
  n, src, option = '', estado = null, motivo = '',
  sinImagen = false, onCambiar, onReintentar, onUsarPrincipal,
}) {
  const cargando = estado === 'cargando';
  const error = estado === 'error';
  return (
    <>
      {/* nº de orden público (P3-7) */}
      <span className="pp-vnum" title="Orden en la tienda (se cambia en Configuración → Catálogo)">{n}</span>
      <div className={`pp-vthumbwrap${cargando ? ' pp-vthumbwrap--cargando' : ''}${error ? ' pp-vthumbwrap--error' : ''}`}>
        {src
          ? <img className={`pp-varthumb${cargando ? ' pp-varthumb--cargando' : ''}`} src={src} alt={option} />
          : <span className={`pp-varthumb pp-varthumb--empty${cargando ? ' pp-varthumb--cargando' : ''}`} title="Sin imagen">—</span>}

        {cargando && (
          <span className="pp-foto-estado pp-foto-estado--cargando" role="status" aria-live="polite">
            <Loader2 size={16} className="pp-spin" aria-hidden="true" /> Cargando…
          </span>
        )}

        {/* Cambiar la foto: oculto mientras carga (no se cambia a mitad de subida). */}
        {!cargando && (
          <button type="button" className="pp-vthumb-cambiar" title="Cambiar la foto"
            aria-label={`Cambiar la foto de la variación ${n}`} onClick={onCambiar}>
            <Camera size={16} aria-hidden="true" />
          </button>
        )}
      </div>

      {error && (
        <div className="pp-foto-estado pp-foto-estado--error" role="alert">
          <span className="pp-foto-error-msg"><AlertCircle size={13} aria-hidden="true" /> {motivo || 'No se pudo cargar la foto.'}</span>
          <button type="button" className="pp-viconbtn pp-foto-reintentar" onClick={onReintentar}
            aria-label={`Reintentar la foto de la variación ${n}`}>
            <RotateCw size={13} aria-hidden="true" /> Reintentar
          </button>
        </div>
      )}

      {/* Usar la imagen principal: solo si no hay imagen y no está cargando/errando. */}
      {sinImagen && !cargando && !error && (
        <button type="button" className="pp-viconbtn" title="Usar la imagen principal"
          aria-label={`Usar la imagen principal en la variación ${n}`} onClick={onUsarPrincipal}>
          <ImagePlus size={15} aria-hidden="true" />
        </button>
      )}
    </>
  );
}
